export default {
  TooltipLeaseDetails:
    "When part payments are made towards the next rental cycle, this will result in a Paid to Effective date that is later than the Paid to Actual date.",
  TooltipLastFullyPaidRentalCycle: "The date of the last fully paid rental cycle."
};
